import { Directive, HostListener, Inject } from '@angular/core';
import { WINDOW_TOKEN } from '@lib/frontend-shared-util-miscellaneous-providers';
import { RefresherCustomEvent } from '@ionic/angular';

@Directive({
    selector: 'ion-refresher[libRefreshWindow]',
    standalone: true,
})
export class RefreshWindowDirective {
    public constructor(@Inject(WINDOW_TOKEN) private readonly window: Window) {}

    @HostListener('ionRefresh', ['$event'])
    public async refresh(event: RefresherCustomEvent) {
        // We don't have async calls to make, so the animation can complete right away.
        await event.target.complete();
        // A slight delay give the refresher icon time to disappear.
        await new Promise((resolve) => setTimeout(resolve, 500));

        this.window.location.reload();
    }
}
